import { z } from "zod";
import { STATUS_IDS } from "../constants.ts";
import {
  EntityIdSchema,
  EntityTypeSchema,
  IsoDate,
  IsoDateTime,
  PositionSchema,
} from "./common.ts";

export const StatusIdSchema = z.enum(STATUS_IDS);

export const EntityStatusSchema = z.object({
  entity_type: EntityTypeSchema,
  entity_id: EntityIdSchema,
  status: StatusIdSchema,
  follow_up: IsoDate.nullable(),
  drive_url: z.string().nullable(),
  /** Manual order within a board column. NULL means fall back to updated_at. */
  board_position: PositionSchema.nullable(),
  updated_at: IsoDateTime,
});

export type EntityStatus = z.infer<typeof EntityStatusSchema>;

export const EntityStatusWriteSchema = z
  .object({
    status: StatusIdSchema,
    follow_up: IsoDate.nullable(),
    drive_url: z.string().url().max(2000).nullable(),
    after_id: EntityIdSchema.nullable(),
    before_id: EntityIdSchema.nullable(),
  })
  .partial();

export type EntityStatusWrite = z.infer<typeof EntityStatusWriteSchema>;

/** Bulk pipeline edit — the board's drag between columns, and the row multi-select. */
export const EntityStatusBulkWriteSchema = z.object({
  entity_type: EntityTypeSchema,
  entity_ids: z.array(EntityIdSchema).min(1).max(10000),
  status: StatusIdSchema.optional(),
  follow_up: IsoDate.nullable().optional(),
  drive_url: z.string().url().max(2000).nullable().optional(),
});

export type EntityStatusBulkWrite = z.infer<typeof EntityStatusBulkWriteSchema>;
